import { IColumn, IconButton, IContextualMenuProps } from "@fluentui/react";

interface InsertEditIconInColumnsProps {
  columns: Array<IColumn>;
  menuProps: IContextualMenuProps;
  selectItem: (item: { id: number }) => void;
}

/**
 * Insere ícones de ações nas colunas da tabela.
 *
 * Esta função percorre as colunas fornecidas e, quando encontra uma coluna com a chave "actions",
 * adiciona um botão de menu (três pontinhos verticais) que exibe opções contextuais.
 *
 * @param columns - Array de colunas da tabela onde os ícones serão inseridos
 * @param menuProps - Propriedades do menu contextual contendo os itens de ação disponíveis
 * @param selectItem - Callback executado ao clicar no menu para selecionar o item atual
 *
 * @returns Array de colunas modificado com os ícones de ação inseridos
 *
 * @remarks
 * A opção "view" (Visualizar) é removida do menu contextual porque muitas tabelas já possuem
 * um ícone dedicado de visualização diretamente na linha da tabela.  Isso evita redundância
 * e melhora a experiência do usuário, mantendo a ação de visualização mais acessível através
 * do ícone específico, enquanto o menu dos três pontinhos fica reservado para ações secundárias
 * como editar, confirmar, cancelar, etc.
 */
export const insertActionsIcons = ({
  columns,
  menuProps,
  selectItem
}: InsertEditIconInColumnsProps) => {
  const filteredMenuProps = {
    ...menuProps,
    items: menuProps?.items?.filter(item => item.key !== "view")
  };

  columns.forEach(column => {
    if (column.key === "actions") {
      column.onRender = (item: { id: number }) => (
        <IconButton
          id={`actions-${item.id}`}
          onMenuClick={() => {
            selectItem(item);
          }}
          menuProps={filteredMenuProps}
          iconProps={{ iconName: "MoreVertical" }}
          onRenderMenuIcon={() => null}
        />
      );
    }
  });

  return columns;
};
